import { styled } from 'styled-components';

export const StyledViewIcons = styled.svg`
  cursor: pointer;
`;
